import { CarrierCustomerAccountBinding, Locale, Vendor, VendorProperties } from "@shared/types";
import { CurrencyObject } from '@client-shared/lib/constants';

export type VendorContextState = [state: VendorState, dispatch: VendorDispatch, utils?: UseVendorUtils];

// Keys used for writing to local storage
export const vendorLocalStorageKeys = {
  vendor: "@vendor",
  currentLocale: "@currentLocale",
  regionLocales: "@regionLocales",
  customerAccountCarrierDetails: "@customerAccountCarrierDetails",
};

export interface VendorState {
  currentVendor: Vendor | undefined;
  currentLocale: Locale | undefined;
  regionLocales: Locale[] | undefined;
  currencyObject: CurrencyObject | undefined;
  customerAccountCarrierDetails?: CarrierCustomerAccountBinding[];
  initialized: boolean;
  loading?: boolean;
  error?: Error;
}

export type SetVendorAction = {
  type: "SET_VENDOR";
  payload: {
    vendor: Vendor | undefined;
  };
};

export type SetCurrencyObjectAction = {
  type: "SET_CURRENCY_OBJECT";
  payload: {
    currencyObject: CurrencyObject | undefined;
  };
};

export type SetCurrentLocaleAction = {
  type: "SET_CURRENT_LOCALE";
  payload: {
    locale: Locale | undefined;
  };
};

export type SetRegionLocalesAction = {
  type: "SET_REGION_LOCALES";
  payload: {
    locales: Locale[] | undefined;
  };
};

export type SetCustomerAccountCarrierDetailsAction = {
  type: "SET_CUSTOMER_ACCOUNT_CARRIER_DETAILS";
  payload: {
    customerAccountCarrierDetails?: CarrierCustomerAccountBinding[];
  };
};

export type SetInitializedAction = {
  type: "SET_INITIALIZED";
  payload: {
    initialized: boolean;
  };
};

export type SetLoadingAction = {
  type: "SET_LOADING";
  payload: {
    loading: boolean;
  };
};

export type SetErrorAction = {
  type: "SET_ERROR";
  payload: {
    error: Error | undefined;
  };
};

export type SetPropertiesAction = {
  type: "SET_VENDOR_PROPERTIES";
  payload: VendorProperties;
};

export type UseVendorUtils = {
  updateProperties: (properties: VendorProperties) => Promise<boolean | undefined>;
  setError: (error: Error) => void;
};

export type VendorActions =
  | SetVendorAction
  | SetInitializedAction
  | SetCurrentLocaleAction
  | SetRegionLocalesAction
  | SetCurrencyObjectAction
  | SetCustomerAccountCarrierDetailsAction
  | SetLoadingAction
  | SetErrorAction
  | SetPropertiesAction;

export type VendorDispatch = React.Dispatch<VendorActions>;
